module.exports = __webpack_public_path__ + "static/media/retirement.4c975d0e.png";